{
  "navTitle": "{{name}} — Пресеты",
  "title": "Пресеты",
  "subtitle": "Сохранённые рецепты шотов с заменяемыми героями, локациями и пропсами.",
  "emptyTitle": "Пресетов пока нет",
  "emptyDescription": "Откройте готовый шот и сохраните его как пресет. Потом можно проверить его глазами будущего пользователя.",
  "createFromShot": "Сохранить шот как пресет",
  "slotsCount": "{{count}} слотов",
  "statusReady": "Готов",
  "statusDraft": "Черновик",
  "filterPlaceholder": "Поиск пресетов",
  "clearFilter": "Очистить",
  "selectHint": "Выберите пресет из списка",
  "referencesTitle": "Референсы",
  "promptTitle": "Промпт",
  "reviewGeneration": "Генерация",
  "reviewStoryboardProvider": "Провайдер сториборда",
  "reviewStoryboardModel": "Модель сториборда",
  "reviewVideoProvider": "Провайдер видео",
  "reviewVideoModel": "Модель видео",
  "reviewDuration": "Длительность",
  "reviewDurationValue": "{{sec}}с",
  "reviewFrameFormat": "Формат кадра",
  "authorMode": "Автор",
  "consumerMode": "Как у пользователя",
  "refreshFromShot": "Обновить из исходного шота",
  "delete": "Удалить",
  "deleteConfirmTitle": "Удалить пресет?",
  "deleteConfirmMessage": "Пресет и его скрытые рабочие шоты будут удалены. Исходный шот останется.",
  "internalEntities": "Оставлены внутренними",
  "hiddenAssets": "Скрытые ассеты",
  "visibleAssets": "Видимые ассеты",
  "noSlots": "Нет заменяемых слотов",
  "required": "Обязательный",
  "optional": "Необязательный",
  "fillSlot": "Выбрать",
  "clearSlot": "Сбросить",
  "generateStoryboard": "Сгенерировать сториборд",
  "generateVideo": "Сгенерировать видео",
  "generating": "Генерация…",
  "assemblePreview": "Собрать превью",
  "assembling": "Собираем…",
  "previewEmpty": "Заполните обязательные слоты, соберите превью и запустите генерацию.",
  "mediaEmpty": "Превью ещё не собрано.",
  "loadFailed": "Не удалось загрузить данные пресета",
  "saveFailed": "Не удалось сохранить пресет",
  "previewFailed": "Не удалось собрать превью",
  "deleted": "Пресет удалён",
  "publish": "Опубликовать в Creator Studio",
  "unpublish": "Снять с публикации",
  "published": "Опубликован",
  "publishCategory": "Категория",
  "publishNeedVideo": "Для публикации нужно видео на шаблоне",
  "publishSuccess": "Опубликовано в Creator Studio",
  "unpublishSuccess": "Снято с публикации",
  "kindCharacter": "Персонаж",
  "kindLocation": "Локация",
  "kindProp": "Проп",
  "wizard": {
    "title": "Создать пресет",
    "editTitle": "Редактировать пресет",
    "stepName": "Имя",
    "stepSlots": "Заменяемые сущности",
    "stepAssets": "Скрытые ассеты",
    "stepReview": "Проверка",
    "reviewHint": "Проверьте пресет перед сохранением. Можно вернуться к любому шагу.",
    "reviewUntitled": "Пресет без названия",
    "reviewSlots": "Заменяемые слоты ({{count}})",
    "reviewNoSlots": "Нет заменяемых слотов",
    "reviewInternal": "Оставлены внутренними ({{count}})",
    "reviewIncludedAssets": "Включённые ассеты ({{count}})",
    "reviewNoAssets": "Нет включённых ассетов",
    "reviewSkippedAssets": "Пропущены ({{count}})",
    "reviewGeneration": "Генерация",
    "reviewProvider": "Провайдер сториборда",
    "reviewStoryboardModel": "Модель сториборда",
    "reviewVideoProvider": "Провайдер видео",
    "reviewVideoModel": "Модель видео",
    "reviewDuration": "Длительность",
    "reviewDurationValue": "{{sec}}с",
    "reviewFrameFormat": "Формат кадра",
    "nameLabel": "Название",
    "descriptionLabel": "Описание",
    "namePlaceholder": "Название пресета",
    "descriptionPlaceholder": "Для чего этот рецепт",
    "slotsHint": "Отметьте, что будущий пользователь подставляет сам. Остальное останется внутри пресета.",
    "modeSlot": "Пользователь подставляет",
    "modeInternal": "Оставить внутренним",
    "required": "Обязательный",
    "assetsHint": "Что из вспомогательных материалов едет вместе с пресетом и видит ли это будущий пользователь.",
    "omit": "Не копировать",
    "hidden": "Включить и скрыть",
    "visible": "Включить и показать",
    "back": "Назад",
    "next": "Далее",
    "create": "Создать пресет",
    "save": "Сохранить",
    "noEntities": "В шоте нет персонажей, локации или пропсов для слотов.",
    "noAssets": "Нет дополнительных референсов или версий, которые можно скрыть.",
    "refKind": "Референс",
    "versionKind": "Версия",
    "active": "Активная",
    "videoDemo": "Демонстрация видео · всегда сохраняется"
  }
}
